module.exports = __webpack_public_path__ + "img/88.64e700df.png";